import { Injectable } from "@angular/core";

@Injectable({providedIn: "root"})
export class FilesService {

    public static base64ToArrayBuffer(file: string): Uint8Array {

        const binaryString = atob(file);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
}